import { render } from "./MentionTextarea.vue?vue&type=template&id=11ec4d50"
import script from "./MentionTextarea.vue?vue&type=script&lang=js"
export * from "./MentionTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__